/**
 * Pure business logic for `settings_screen.tsx` (C6, #21937) — extracted per
 * CLAUDE.md's "components >150 lines extract business logic to co-located
 * pure .ts files" rule. No React, no network; unit-testable in isolation.
 */
import type { OrganisationSettings } from '../../data/types';

/**
 * Whether the base-currency field should render disabled — either
 * pre-emptively (a posted pay run already implies a real journal exists for
 * this entity, so the backend's currency lock will certainly reject any
 * change) or reactively (the most recent save attempt was rejected
 * specifically for that same lock).
 */
export function isCurrencyFieldDisabled(
  hasPostedPayRun: boolean,
  currencyLocked: boolean,
): boolean {
  return hasPostedPayRun || currencyLocked;
}

/**
 * Resets ONLY `base_currency` back to the last-known-good persisted value,
 * preserving every other field of `draft` untouched — the specific recovery
 * behavior a `currency_locked` save rejection must produce. Without this,
 * the user would have to re-type every other field they'd also changed in
 * the same submit (e.g. the legal entity name) just to retry with a
 * currency they never meant to change in the first place.
 */
export function resetLockedCurrencyField(
  draft: OrganisationSettings,
  lastPersisted: OrganisationSettings,
): OrganisationSettings {
  return { ...draft, base_currency: lastPersisted.base_currency };
}
